module.exports = __webpack_public_path__ + "img/cover-mini-baiser-d-ecumes.4850ea29.jpg";